(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kashpel-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.getElementById('kp-pd');
  if (!root) return;

  var productData = JSON.parse(root.dataset.product);
  var selected = {};

  // Seed selected state from server-rendered .on buttons
  root.querySelectorAll('[data-opt].on').forEach(function(btn) {
    selected[btn.dataset.opt] = btn.dataset.value;
  });

  var shopCurrency = root.dataset.currency || 'SEK';
  var shopLocale = root.dataset.locale || 'sv-SE';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(shopLocale, { style: 'currency', currency: shopCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function matchVariant() {
    var v = productData.variants.find(function(variant) {
      return variant.options.every(function(opt, i) {
        return opt === selected[i + 1];
      });
    });

    // No variant exists for this combination. Clear the variant ID and lock the
    // purchase controls: leaving the previous ID in place would let the customer
    // add a variant they are no longer looking at.
    if (!v) {
      var idInput = root.querySelector('[data-variant-id]');
      if (idInput) idInput.value = '';

      var addUnavail = root.querySelector('.kp-pd-add');
      var buyUnavail = root.querySelector('.kp-pd-buynow');
      if (addUnavail) addUnavail.disabled = true;
      if (buyUnavail) buyUnavail.disabled = true;

      var stockUnavail = root.querySelector('.kp-pd-stock');
      if (stockUnavail) {
        var dotUnavail = stockUnavail.querySelector('.kp-dot');
        if (dotUnavail) dotUnavail.className = 'kp-dot is-out';
        stockUnavail.childNodes[stockUnavail.childNodes.length - 1].textContent =
          stockUnavail.dataset.stockUnavailable || stockUnavail.dataset.stockOut;
      }
      return;
    }

    root.querySelector('[data-variant-id]').value = v.id;

    // Price
    var priceEl = root.querySelector('[data-price]');
    var addPriceEl = root.querySelector('[data-add-price]');
    var priceFormatted = formatMoney(v.price);
    if (priceEl) {
      priceEl.textContent = priceFormatted;
      priceEl.classList.toggle('is-sale', !!(v.compare_at_price && v.compare_at_price > v.price));
    }
    if (addPriceEl) addPriceEl.textContent = priceFormatted;

    // Compare-at price + saving badge
    var compareEl = root.querySelector('[data-compare]');
    var savingEl = root.querySelector('.kp-pd-saving');
    var saleBadge = root.querySelector('[data-sale-badge]');
    var isSale = !!(v.compare_at_price && v.compare_at_price > v.price);
    if (compareEl) {
      compareEl.textContent = isSale ? formatMoney(v.compare_at_price) : '';
      compareEl.hidden = !isSale;
    }
    if (savingEl) {
      if (isSale) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        savingEl.textContent = '−' + pct + '%';
      }
      savingEl.hidden = !isSale;
    }
    if (saleBadge) saleBadge.hidden = !isSale;

    // Add / buy buttons
    var addBtn = root.querySelector('.kp-pd-add');
    var buyBtn = root.querySelector('.kp-pd-buynow');
    if (addBtn) addBtn.disabled = !v.available;
    if (buyBtn) buyBtn.disabled = !v.available;

    // Stock text
    var stockEl = root.querySelector('.kp-pd-stock');
    if (stockEl) {
      var dot = stockEl.querySelector('.kp-dot');
      var stockText;
      if (v.available) {
        if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
          stockText = stockEl.dataset.stockLow.replace('__COUNT__', v.inventory_quantity);
        } else {
          stockText = stockEl.dataset.stockIn;
        }
        if (dot) { dot.className = 'kp-dot'; }
      } else {
        stockText = stockEl.dataset.stockOut;
        if (dot) { dot.className = 'kp-dot is-out'; }
      }
      stockEl.childNodes[stockEl.childNodes.length - 1].textContent = stockText;
    }

    // Gallery: switch the main media to this variant's media.
    var variantMediaId = (v.featured_media && v.featured_media.id) ? String(v.featured_media.id) : null;
    if (variantMediaId) {
      var matchThumb = root.querySelector('.kp-pd-thumb[data-media-id="' + variantMediaId + '"]');
      if (matchThumb) {
        // The variant's media exists as a thumbnail — activate it.
        showMedia(matchThumb);
      } else if (v.featured_image) {
        // No matching thumbnail: show the variant image and clear active state.
        showImage(v.featured_image.src);
        clearActiveThumbs();
      }
    } else if (v.featured_image) {
      showImage(v.featured_image.src);
      clearActiveThumbs();
    }
  }

  // ——— Gallery media helpers ———
  var stage = document.getElementById('kp-pd-main-img');

  function clearActiveThumbs() {
    root.querySelectorAll('.kp-pd-thumb').forEach(function(t) { t.classList.remove('on'); });
  }

  // Replace the stage contents with a plain image (used for variant images
  // that have no corresponding product media item).
  function showImage(src) {
    if (!stage || !src) return;
    pauseStageMedia();
    var img = stage.querySelector('img');
    if (!img || img.closest('template')) {
      img = document.createElement('img');
      img.className = 'kp-slot';
    }
    img.src = src;
    img.alt = (productData && productData.title) ? productData.title : '';
    img.removeAttribute('srcset');
    stage.innerHTML = '';
    stage.appendChild(img);
  }

  // Pause any playing HTML5 video before swapping media out.
  function pauseStageMedia() {
    if (!stage) return;
    stage.querySelectorAll('video').forEach(function(vid) {
      try { vid.pause(); } catch (e) {}
    });
  }

  // Show the media represented by a thumbnail in the main stage.
  function showMedia(thumb) {
    if (!thumb || !stage) return;
    clearActiveThumbs();
    thumb.classList.add('on');

    var type = thumb.dataset.mediaType || 'image';
    if (type === 'image') {
      showImage(thumb.dataset.thumb);
      return;
    }

    // Video / external video / model: inject its stored playable markup.
    var tpl = thumb.querySelector('template[data-media-markup]');
    pauseStageMedia();
    stage.innerHTML = '';
    if (tpl && tpl.content) {
      stage.appendChild(tpl.content.cloneNode(true));
      // Try to start playback for native videos. Browsers block autoplay with
      // sound, so mute first to improve the odds; controls remain visible so the
      // customer can unmute or press play if the browser still blocks it.
      var vid = stage.querySelector('video');
      if (vid) {
        vid.muted = true;
        var p = vid.play();
        if (p && typeof p.catch === 'function') { p.catch(function() {}); }
      }
    } else if (thumb.dataset.thumb) {
      showImage(thumb.dataset.thumb);
    }
  }

  // Swatch / size option buttons
  root.querySelectorAll('[data-opt]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var pos = btn.dataset.opt;
      selected[pos] = btn.dataset.value;
      btn.parentElement.querySelectorAll('[data-opt]').forEach(function(b) {
        b.classList.remove('on');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('on');
      btn.setAttribute('aria-pressed', 'true');
      var labelVal = root.querySelector('[data-opt-value="' + pos + '"]');
      if (labelVal) labelVal.textContent = btn.dataset.value;
      matchVariant();
    });
  });

  // Thumbnail gallery — click swaps the main stage (image or video).
  root.querySelectorAll('.kp-pd-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      showMedia(thumb);
    });
  });

  // Qty stepper
  var qtyWrap = root.querySelector('[data-qty]');
  if (qtyWrap) {
    var qtyDisplay = qtyWrap.querySelector('.kp-qty-n');
    var qtyInput = qtyWrap.querySelector('[data-qty-input]');
    var minusBtn = qtyWrap.querySelector('[data-step="-1"]');

    function updateQty(val) {
      val = Math.max(1, val);
      if (qtyDisplay) qtyDisplay.textContent = val;
      if (qtyInput) qtyInput.value = val;
      if (minusBtn) minusBtn.disabled = val <= 1;
      // update price display
      var addPriceEl = root.querySelector('[data-add-price]');
      if (addPriceEl && productData) {
        var varId = parseInt(root.querySelector('[data-variant-id]').value);
        var v = productData.variants.find(function(variant) { return variant.id === varId; });
        if (v) {
          addPriceEl.textContent = formatMoney(v.price * val);
        }
      }
    }

    qtyWrap.querySelectorAll('[data-step]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var current = parseInt(qtyDisplay ? qtyDisplay.textContent : '1') || 1;
        updateQty(current + parseInt(btn.dataset.step));
      });
    });
  }

  // Accordion — drive open height from scrollHeight so any length of content
  // shows fully (no fixed max-height clip) while keeping the slide animation.
  function openAcc(item) {
    var body = item.querySelector('.kp-acc-body');
    if (!body) return;
    item.classList.add('is-open', 'is-animating');
    body.style.maxHeight = '0px';
    void body.offsetHeight;
    body.style.maxHeight = body.scrollHeight + 'px';
    // After the open transition, drop the fixed px so the panel can grow if
    // content reflows (font load, resize) without re-clipping.
    var finished = false;
    var finish = function() {
      if (finished) return;
      finished = true;
      if (item.classList.contains('is-open')) body.style.maxHeight = 'none';
      item.classList.remove('is-animating');
      body.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function(e) {
      if (e.propertyName !== 'max-height') return;
      finish();
    };
    body.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 380);
  }

  function closeAcc(item) {
    var body = item.querySelector('.kp-acc-body');
    if (!body) return;
    // If currently 'none', pin to the current px height first so the collapse
    // has a value to animate from.
    if (body.style.maxHeight === 'none') {
      body.style.maxHeight = body.scrollHeight + 'px';
      // Force reflow so the browser registers the starting height.
      void body.offsetHeight;
    }
    item.classList.add('is-animating');
    item.classList.remove('is-open');
    body.style.maxHeight = '0px';
    var finished = false;
    var finish = function() {
      if (finished) return;
      finished = true;
      item.classList.remove('is-animating');
      body.style.maxHeight = '';
      body.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function(e) {
      if (e.propertyName !== 'max-height') return;
      finish();
    };
    body.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 380);
  }

  root.querySelectorAll('.kp-acc-head').forEach(function(head) {
    head.addEventListener('click', function() {
      var item = head.closest('.kp-acc-item');
      var wasOpen = item.classList.contains('is-open');
      // Close all, then open the clicked one if it was closed.
      root.querySelectorAll('.kp-acc-item').forEach(function(i) {
        if (i.classList.contains('is-open')) closeAcc(i);
      });
      if (!wasOpen) openAcc(item);
    });
  });

  // Mark accordions ready so the collapse CSS applies (no-JS keeps content
  // visible). Then set the open item's height with no transition so it does
  // not animate or shift on page load.
  root.querySelectorAll('.kp-acc').forEach(function(acc) {
    acc.classList.add('is-ready');
  });
  root.querySelectorAll('.kp-acc-item.is-open').forEach(function(item) {
    var body = item.querySelector('.kp-acc-body');
    if (!body) return;
    // Open to natural height with no animation (avoids a load-time slide/shift).
    var prev = body.style.transition;
    body.style.transition = 'none';
    body.style.maxHeight = 'none';
    void body.offsetHeight; // flush before restoring the transition
    body.style.transition = prev;
  });

  function ajaxAddToCart(variantId, qty, redirectToCheckout) {
    // Guard against an unresolved option combination: matchVariant() clears the
    // hidden input when no variant matches, so there is nothing valid to add.
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(body) { throw new Error(body.description || r.status); });
      return r.json();
    })
    .then(function() {
      if (redirectToCheckout) {
        window.location.href = '/checkout';
      } else {
        document.dispatchEvent(new CustomEvent('kashpel:cart:open'));
      }
    })
    .catch(function(err) {
      if (buyNowBtn) buyNowBtn.disabled = false;
      var fallback = root && root.dataset.addError ? root.dataset.addError : 'Could not add to cart.';
      var msg = (err && err.message) ? err.message : fallback;
      if (window.KashpelShowCartError) { window.KashpelShowCartError(msg); } else { alert(msg); }
    });
  }

  var form = document.getElementById('kp-pd-form');

  // Buy now — add to cart then go to checkout
  var buyNowBtn = document.getElementById('kp-buynow-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      if (buyNowBtn.disabled) return;
      buyNowBtn.disabled = true;
      var variantId = form.querySelector('[data-variant-id]').value;
      var qty = form.querySelector('[data-qty-input]').value || 1;
      ajaxAddToCart(variantId, qty, true);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
